import { gql } from 'graphql-request';

export const GET_SUPPLY_DOCUMENT_SCHEME = gql`
  query App12d801b5_Document($documentId: String) {
    app12d801b5_Document {
      getTemplate(documentId: $documentId) {
        template {
          step
          name
          type
          value
          required
          isSearchable
          placeholder
          fieldTransform
          fieldType
          label {
            en
            ru
          }
          stepLabel
          validation
          options {
            label
            value
          }
        }
      }
    }
  }
`;
